module.exports = __webpack_public_path__ + "img/sbo_logo.d264aa24.png";